import React from "react";
import Button from "../Button";

const ErrorDescription = ({error}) => {

    const codeMapper = new Map([
        [-33502, "Некорректные данные для входа/Invalid credentials"],
        [-33501, "Radius server не отвечает. Проверьте доступность сервера и корректность shared secret"],
        [-33500, "Ожидание ответа сервера..."],
        [-33499, "Ошибка входа. Повторите попытку или воспользуйтесь другим браузером"],
        [-33498, "Превышен лимит подключаемых устройств на пользователя"],
        [-33497, "Превышен лимит времени ожидания"],

        [-32503, "Используйте другой номер для регистрации. Текущий номер недопустим"],
        [-32502, "Устройство заблокировано по списку Blacklist"],
        [-32501, "Пользователь заблокирован по списку Blacklist"],

        [-31505, "Хотспот административно отключен"],
        [-31504, "Услуга временно не работает. Работа согласно расписанию"],
        [-31503, "Ресурс заблокирован из-за не оплаты, обратитесь к менеджеру продаж"],
        [-31502, "Ресурс удалён, обратитесь к менеджеру продаж"],
        [-31501, "Уникальный идентификатор ресурса не найден. Настройте хотспот"],

        [-30501, "Превышено допустимое количество пользователей на оборудовании. Ограничение лицензии маршрутизатора"],
        [-30500, "Израсходован пакет данных"],
        [-30499, "Израсходован лимит сеанса по времени доступа"]
    ])
    
    const codeCheck = (error) => {
        if (!!error.code && codeMapper.has(error.code)) {
            return codeMapper.get(error.code)
        }
        return error.message
    }

    return (
        <>
        <p>{codeCheck(error)}</p>
        <Button onClick={()=>window.location.assign("http://gowifi.ru")}
            description={"Повторить попытку"}
        />
        </>
    )
}

export default ErrorDescription